import * as m from "../../model/model";

import { CUser } from "./CUser";

export class CUsers {
  json: m.FbUser[];
  // users: CUser[];

  constructor(json: m.FbUser[]) {
    this.json = json;
    // this.users = (json || []).map((user) => new CUser(user));
  }

  get users() {
    return this.json;
  }

  filter(filter: { search: string }) {
    const search = filter.search || "";
    return this.users
      .filter((user) => !!user)
      .filter(
        (user) =>
          user.name.toLowerCase().search(search.toLowerCase()) > -1 ||
          user.email.toLowerCase().search(search.toLowerCase()) > -1
      )
      .sort((user1, user2) => user1.name.localeCompare(user2.name));
  }

  findUser(user: CUser) {
    return this.users.find((u) => u.key === user.key);
  }
}
